module.exports = __webpack_public_path__ + "img/SA_provinces.13165806.svg";